import React, { useMemo } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { useDeleteUserIntegrationMutation, useGetMeQuery } from '../../../../store/user/user'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { createState, IntegrationServiceId } from '../../../../common/integrations'
import '../IntegrationsTab.scss'
import { EmailConnectButton } from '../../../../components/EmailConnectButton/EmailConnectButton'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'

export type GmailIntegrationRowProps = { useIntegrationRedirectUri?: boolean }

export const GmailIntegrationRow: React.FC<GmailIntegrationRowProps> = ({ useIntegrationRedirectUri }) => {
  const accountId = useAppSelector(selectAccountId)

  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()

  const hasGmailIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.serviceId === IntegrationServiceId.GMAIL))
  }, [userData])

  const hasOtherMailIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.type === 'mail' && i.serviceId !== IntegrationServiceId.GMAIL))
  }, [userData])

  const redirectState = useIntegrationRedirectUri ? createState(window.location.origin + '/dashboard/account/profile-settings/integrations') : createState()

  const uninstallGmail = () => {
    const user = userData
    const integration = user!.integrations!.find((i) => i.serviceId === IntegrationServiceId.GMAIL)
    deleteUserIntegration({
      accountId,
      payload: {
        userId: user!.id,
        integrationId: integration!.id,
      },
    })
  }

  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      <Row className='d-flex justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100'>
              <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={48} height={48} />
            </div>
            <div>
              <h6>Gmail</h6>
              <div>Connect your Zocks account to Gmail.</div>
            </div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-3 align-items-start'>
            <div className='connect-button-container'>
              {hasGmailIntegration ? (
                <div className='connect-button-container'>
                  <Button variant='primary' onClick={uninstallGmail} loading={isDeletingIntegration}>
                    Disconnect
                  </Button>
                  <div className='pt-2 d-flex justify-content-end zocks-text-success'>
                    <i className='bi bi-check' />
                    Connected
                  </div>
                </div>
              ) : (
                <EmailConnectButton serviceId={IntegrationServiceId.GMAIL} redirectState={redirectState} hasOtherMailIntegration={hasOtherMailIntegration}>
                  Connect
                </EmailConnectButton>
              )}
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
